import React from 'react';
import { CheckCircle2, Target, Eye, Award } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { Card } from '../components/ui/card';
import { certifications } from '../data/mockData';

const About = () => {
  const { language } = useLanguage();

  const content = {
    en: {
      title: 'About IVARME Trading Company',
      subtitle: 'Indian Excellence for Global Markets',
      intro1: 'IVARME Trading Company is a registered Indian enterprise specialising in procurement, export and engineering design services. We connect global buyers with high-quality Indian products. We also deliver professional CAD and MEP design solutions trusted by international clients.',
      intro2: 'With a strong presence across Vietnam, the Middle East, and Africa, IVARME serves as a reliable B2B export partner for industries seeking cost-effective, compliant, and high-performance equipment. Our portfolio includes industrial machinery, mechanical, electrical & plumbing (MEP) systems, water pumps, pipe fittings, valves, swimming pool equipment, and water treatment chemicals—all sourced from verified Indian manufacturers.',
      intro3: 'Our engineering services division provides CAD drafting, production drawings, and MEP design consultancy aligned with ASME and ISO standards. By integrating precision engineering with global export expertise, we ensure clients receive end-to-end solutions—from design to delivery.',
      intro4: 'At IVARME Trading Company, our job is to be your trusted partner for industrial procurement, engineering services outsourcing, and merchant export from India.',
      ourMission: 'Our Mission',
      missionText: 'To provide quality industrial products and engineering services that meet international standards, enabling our clients to build better infrastructure and achieve operational excellence.',
      ourVision: 'Our Vision',
      visionText: 'To become a trusted partner for B2B clients worldwide, recognized for reliability, technical expertise, and commitment to customer success.',
      whyChooseUs: 'Why Choose IVARME',
      certifiedBusiness: 'Certified Business',
      certifiedBusinessDesc: 'Registered Indian Enterprise with license to Import & Export issued by the DGFT, India.',
      qualityAssurance: 'Quality Assurance',
      qualityAssuranceDesc: 'Products comply with international standards (ISO, ASME, IS)',
      competitive: 'Competitive Pricing',
      competitiveDesc: 'Direct sourcing and AIFTA benefits for Vietnam market',
      support: '24/7 Support',
      supportDesc: 'Multilingual support in English and Vietnamese'
    },
    vi: {
      title: 'Về Công ty TNHH IVARME',
      subtitle: 'Sự xuất sắc của Ấn Độ cho thị trường toàn cầu',
      intro1: 'Công ty TNHH IVARME là doanh nghiệp Ấn Độ đã đăng ký chuyên về mua sắm, xuất khẩu và dịch vụ thiết kế kỹ thuật. Chúng tôi kết nối người mua toàn cầu với sản phẩm Ấn Độ chất lượng cao. Chúng tôi cũng cung cấp giải pháp thiết kế CAD và MEP chuyên nghiệp được khách hàng quốc tế tin tưởng.',
      intro2: 'Với sự hiện diện mạnh mẽ tại Việt Nam, Trung Đông và Châu Phi, IVARME đóng vai trò là đối tác xuất khẩu B2B đáng tin cậy cho các ngành công nghiệp tìm kiếm thiết bị hiệu suất cao, tuân thủ và tiết kiệm chi phí. Danh mục của chúng tôi bao gồm máy móc công nghiệp, hệ thống cơ khí, điện & ống nước (MEP), máy bơm nước, phụ kiện ống, van, thiết bị hồ bơi và hóa chất xử lý nước—tất cả đều có nguồn gốc từ các nhà sản xuất Ấn Độ được xác minh.',
      intro3: 'Bộ phận dịch vụ kỹ thuật của chúng tôi cung cấp bản vẽ CAD, bản vẽ sản xuất và tư vấn thiết kế MEP phù hợp với tiêu chuẩn ASME và ISO. Bằng cách tích hợp kỹ thuật chính xác với chuyên môn xuất khẩu toàn cầu, chúng tôi đảm bảo khách hàng nhận được giải pháp toàn diện—từ thiết kế đến giao hàng.',
      intro4: 'Tại Công ty TNHH IVARME, công việc của chúng tôi là trở thành đối tác đáng tin cậy của bạn cho mua sắm công nghiệp, thuê ngoài dịch vụ kỹ thuật và xuất khẩu thương mại từ Ấn Độ.',
      ourMission: 'Sứ mệnh của chúng tôi',
      missionText: 'Cung cấp sản phẩm công nghiệp chất lượng và dịch vụ kỹ thuật đáp ứng tiêu chuẩn quốc tế, giúp khách hàng xây dựng cơ sở hạ tầng tốt hơn và đạt được sự xuất sắc trong hoạt động.',
      ourVision: 'Tầm nhìn của chúng tôi',
      visionText: 'Trở thành đối tác đáng tin cậy cho khách hàng B2B trên toàn thế giới, được công nhận về độ tin cậy, chuyên môn kỹ thuật và cam kết với thành công của khách hàng.',
      whyChooseUs: 'Tại sao chọn IVARME',
      certifiedBusiness: 'Doanh nghiệp được chứng nhận',
      certifiedBusinessDesc: 'Doanh nghiệp Ấn Độ đã đăng ký với giấy phép Nhập & Xuất khẩu do DGFT, Ấn Độ cấp.',
      qualityAssurance: 'Đảm bảo chất lượng',
      qualityAssuranceDesc: 'Sản phẩm tuân thủ tiêu chuẩn quốc tế (ISO, ASME, IS)',
      competitive: 'Giá cạnh tranh',
      competitiveDesc: 'Nguồn cung ứng trực tiếp và lợi ích AIFTA cho thị trường Việt Nam',
      support: 'Hỗ trợ 24/7',
      supportDesc: 'Hỗ trợ đa ngôn ngữ bằng tiếng Anh và tiếng Việt'
    }
  };

  const t = content[language];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <section className="bg-gradient-to-r from-[#264f78] to-[#1a3a57] text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">{t.title}</h1>
            <p className="text-lg text-white/90">{t.subtitle}</p>
          </div>
        </div>
      </section>

      {/* Introduction */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-6">
          <p className="text-lg text-gray-700 leading-relaxed">
            {t.intro1}
          </p>
          <p className="text-lg text-gray-700 leading-relaxed">
            {t.intro2}
          </p>
          <p className="text-lg text-gray-700 leading-relaxed">
            {t.intro3}
          </p>
          <p className="text-lg text-gray-700 leading-relaxed">
            {t.intro4}
          </p>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <Card className="p-8">
              <div className="w-16 h-16 bg-[#264f78]/10 rounded-full flex items-center justify-center mb-4">
                <Target className="w-8 h-8 text-[#264f78]" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">{t.ourMission}</h2>
              <p className="text-gray-600 leading-relaxed">{t.missionText}</p>
            </Card>

            <Card className="p-8">
              <div className="w-16 h-16 bg-[#264f78]/10 rounded-full flex items-center justify-center mb-4">
                <Eye className="w-8 h-8 text-[#264f78]" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">{t.ourVision}</h2>
              <p className="text-gray-600 leading-relaxed">{t.visionText}</p>
            </Card>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 text-center mb-12">{t.whyChooseUs}</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-[#264f78]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <Award className="w-10 h-10 text-[#264f78]" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">{t.certifiedBusiness}</h3>
              <p className="text-sm text-gray-600">{t.certifiedBusinessDesc}</p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-[#264f78]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <CheckCircle2 className="w-10 h-10 text-[#264f78]" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">{t.qualityAssurance}</h3>
              <p className="text-sm text-gray-600">{t.qualityAssuranceDesc}</p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-[#264f78]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <Target className="w-10 h-10 text-[#264f78]" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">{t.competitive}</h3>
              <p className="text-sm text-gray-600">{t.competitiveDesc}</p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-[#264f78]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <CheckCircle2 className="w-10 h-10 text-[#264f78]" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">{t.support}</h3>
              <p className="text-sm text-gray-600">{t.supportDesc}</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
